"use strict";Object.defineProperty(exports, "__esModule", {value: true});// The customer changelog: the one source for the public page at
// bloomtext.com/whats-new/, the apps' "What's New" pill, Settings row and tab
// dot (which link to that page), and the customer email. Newest release
// first; changes in each release are ordered most noticeable first.
//
// Copy is hand-written for customers: no commit subjects, PR numbers or
// em dashes. Ids are permanent: they are the page anchors and the media file
// names, so never rename one. A release's id is its date: the apps show the
// pill again when the newest release's date is later than the moment a
// person dismissed it, so adding a release and running Website Deploy
// brings it back. How to publish: CHANGELOG-README.md.
//
// Clips live outside the site build under whatsNewMediaUrl/<release id>/,
// each recording cut into these renditions (versioned by its `file`):
//   <file>-page.webp         880x595 animated WebP, public page
//   <file>-page-poster.webp  880x595 still, under the play button
//   <file>-email.gif         600x406 GIF, email only
// A clip that is not uploaded yet stays hidden, so the entry shows its title
// and sentence only; uploading the files shows it with no deploy.


























 const whatsNewUrl = 'https://www.bloomtext.com/whats-new/'; exports.whatsNewUrl = whatsNewUrl
// Uploaded with Cache-Control 'public, max-age=31536000, immutable': a changed
// clip needs a new file name (or release folder), since overwriting one keeps
// serving the old file from browser and CDN caches for up to a year.
 const whatsNewMediaUrl = 'https://www.bloomtext.com/whats-new/media'; exports.whatsNewMediaUrl = whatsNewMediaUrl
/** The newest release, which every website deploy publishes from this file
 * (apps/website/scripts/generate-whats-new.js) so the apps pick up a release
 * without an app update. */
 const whatsNewLatestUrl = 'https://www.bloomtext.com/whats-new.json'; exports.whatsNewLatestUrl = whatsNewLatestUrl

 const changelog = [
  {
    id: '2026-10-19',
    changes: [
      {
        id: 'new-look',
        title: 'The new look',
        summary: 'The inbox, chat, composer, sidebar, Directory and sign-in screens share a softer, cleaner design, with a tab bar on phones.',
        clips: [
          { file: 'new-look-reply-v1', alt: 'Replying to a patient in the redesigned inbox with the paper-plane button, and their inbox row moving to the top' },
          { file: 'new-look-directory-v1', alt: "Searching the redesigned Directory for a coworker and opening Priya Nair's page" },
        ],
      },
      {
        id: 'photos-and-files',
        title: 'Photos and files together',
        summary: 'Send text plus up to 10 photos or files as one message; photos show as a grid with the caption under it, and any file can be downloaded from the message menu.',
        clips: [
          { file: 'photos-and-files-grid-v1', alt: 'Three photos and a caption sent as one message that shows as a photo grid' },
          { file: 'photos-and-files-download-v1', alt: 'Downloading a file from the message menu and confirming the save prompt' },
        ],
      },
      {
        id: 'inbox-filters',
        title: 'Inbox filters',
        summary: 'All, Unread, Patients, Staff and Scheduled filters narrow your inbox to the chats you need, and opening a chat marks it read.',
        clips: [
          { file: 'inbox-filters-v1', alt: 'Opening a chat from the Unread filter and the row turning read' },
        ],
      },
      {
        id: 'new-chat',
        title: 'New chat',
        summary: 'The + button opens one New chat sheet to message a patient or coworker, start a group or add a patient.',
        clips: [
          { file: 'new-chat-v1', alt: 'Picking a person in the New chat sheet and the new chat opening' },
        ],
      },
      {
        id: 'send-later',
        title: 'Send later',
        summary: 'Write a message now and pick when it goes out; it waits in the chat as a Scheduled message you can edit, send now or cancel.',
        clips: [
          { file: 'send-later-v1', alt: 'Scheduling a message for tomorrow and the Scheduled message waiting in the chat with Edit, Send now and Cancel' },
        ],
      },
      {
        id: 'templates',
        title: 'Templates in any chat',
        summary: 'Save a message as a template and insert it from the composer, filling in details such as the appointment date.',
        clips: [
          { file: 'templates-v1', alt: 'Typing the visit time into an appointment reminder template and the preview filling in' },
        ],
      },
      {
        id: 'translation',
        title: 'Translation',
        summary: 'Messages from patients in another language show in English with the original one tap away, and your replies reach them in their language.',
        clips: [
          { file: 'translation-v1', alt: "A patient's message in Spanish switching to English, marked Translated from Spanish" },
        ],
      },
      {
        id: 'personalized-broadcasts',
        title: 'Personalized broadcasts',
        summary: "Broadcasts fill in each recipient's name from your list, with fallbacks; pick recipients from your patients, import large lists in the background, and send now or schedule from one Send button.",
        audience: 'Web and desktop',
        clips: [
          { file: 'personalized-broadcasts-preview-v1', alt: 'A broadcast preview filling in "Hi Maria" for one recipient' },
          { file: 'personalized-broadcasts-import-v1', alt: 'Importing a CSV list into a broadcast: 30 recipients added, 26 new and 4 existing' },
        ],
      },
      {
        id: 'patients-table',
        title: 'Patients table',
        summary: 'See every patient in one table with Active and Archived views, and tag, broadcast to or archive many patients at once.',
        audience: 'Web and desktop; archive on phones',
        clips: [
          { file: 'patients-table-v1', alt: 'Tagging several patients at once in the Patients table' },
        ],
      },
      {
        id: 'opt-outs',
        title: 'Opt-outs in one place',
        summary: 'Mark a patient opted out or resubscribe them with a reason, and see every opt-out and block in one Undeliverable list.',
        clips: [
          { file: 'opt-outs-v1', alt: 'Marking a patient opted out with a reason, and their details showing who marked it' },
        ],
      },
      {
        id: 'text-start',
        title: 'Ask them to text START',
        summary: 'When a carrier blocks a number, BloomText shows which line the patient should text START to, and START clears it.',
        clips: [
          { file: 'text-start-v1', alt: 'A banner telling staff the carrier blocks texts and which number the patient can text START to' },
        ],
      },
      {
        id: 'hide-phone-numbers',
        title: 'Hide patient phone numbers',
        summary: 'Admins can hide patient phone numbers from other staff.',
        audience: 'Admins turn it on',
        clips: [
          { file: 'hide-phone-numbers-v1', alt: 'The Patients table with phone numbers masked except the last four digits' },
        ],
      },
      {
        id: 'spam-protection',
        title: 'Spam protection',
        summary: 'Suspicious patient messages carry a "Possible spam" badge with one-click Block, and new organizations\' texts are checked for scams.',
        clips: [
          { file: 'spam-protection-v1', alt: 'Blocking a number from its chat, and the banner that shows it is blocked, with Unblock' },
        ],
      },
      {
        id: 'feedback',
        title: 'Feedback reaches support',
        summary: 'The Feedback button sends your question, idea or bug straight to BloomText Support and opens that chat.',
        clips: [
          { file: 'feedback-v1', alt: 'Sending feedback and the new chat with BloomText Support opening' },
        ],
      },
      {
        id: 'patient-app',
        title: 'Patient app',
        summary: "Patients can sign in to the BloomText app with a code, see their care team's chats, reply live and get push alerts instead of texted links.",
        audience: 'Patients on iOS and Android',
        clips: [
          { file: 'patient-app-v2', alt: "A patient asking about parking in the BloomText app and the care team's reply appearing live" },
        ],
      },
      {
        id: 'patient-api',
        title: 'Patient API',
        summary: 'A clinic\'s own system can text and sync patients through BloomText, and staff see those messages as "Reminder service · API".',
        audience: 'Admins, through the API',
        clips: [
          { file: 'patient-api-v1', alt: 'A message labeled "Reminder service · API" in a patient chat' },
        ],
      },
    ],
    smallerChanges: 'Team management is admin-only; a patient\'s first text ends with "Reply STOP to stop", editable by admins; read receipts show as avatar dots; chats open on the latest message; the notifications prompt stops repeating; and small fixes.',
  },
]; exports.changelog = changelog

/** Midnight UTC on a YYYY-MM-DD date; NaN for anything else. */
 const dateTime = (date) => (/^\d{4}-\d{2}-\d{2}$/.test(date) ? Date.parse(`${date}T00:00:00Z`) : NaN); exports.dateTime = dateTime

/** Midnight UTC on a release's date. */
 const releaseTime = (release) => exports.dateTime.call(void 0, release.id); exports.releaseTime = releaseTime

/** The newest release built into this app. */
 const newestReleaseTime = exports.releaseTime.call(void 0, exports.changelog[0]); exports.newestReleaseTime = newestReleaseTime

/** The body of /whats-new.json: only what the pill needs. */
 const whatsNewLatest = () => {
  const release = exports.changelog[0]
  return { latest: { date: release.id, title: release.changes[0].title, url: exports.whatsNewUrl } }
}; exports.whatsNewLatest = whatsNewLatest



const clipFile = {
  'page': 'page.webp',
  'page-poster': 'page-poster.webp',
  'email': 'email.gif',
}

 const clipUrl = (release, clip, rendition) =>
  `${exports.whatsNewMediaUrl}/${release.id}/${clip.file}-${clipFile[rendition]}`; exports.clipUrl = clipUrl

/** "October 19, 2026" from a YYYY-MM-DD release id, in any time zone. */
 const releaseDate = (release) =>
  new Date(exports.releaseTime.call(void 0, release))
    .toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' }); exports.releaseDate = releaseDate
